import axiosInstance from '../../api/axiosInstance';
import { LifecycleReplayPage, parseLifecycleEvent } from './types';

const MAX_REPLAY_PAGE_SIZE = 200;

export const replayLifecycleEvents = async (
  sessionId: string,
  workerId: string,
  afterCursor: number,
): Promise<LifecycleReplayPage> => {
  const response = await axiosInstance.get(`/conversation-turns/sessions/by-id/${encodeURIComponent(sessionId)}/events`, {
    params: { afterCursor, limit: MAX_REPLAY_PAGE_SIZE },
  });
  const raw = response.data as Record<string, unknown>;
  const events = Array.isArray(raw.events)
    ? raw.events
      .map((event) => parseLifecycleEvent(event, workerId, sessionId))
      .filter((event): event is NonNullable<typeof event> => event !== null)
    : [];
  return {
    events,
    nextCursor: Number.isSafeInteger(raw.nextCursor) ? Number(raw.nextCursor) : afterCursor,
    synchronized: raw.synchronized === true,
    hasMore: raw.hasMore === true,
    cursorExpired: raw.cursorExpired === true,
  };
};
